<div id="main" class="d-flex flex-column" style="height: calc(100vh - 65px); overflow-y: hidden;">
  <div class="top-section" style="background-color: #673AB7;">
    <div class="ordercount-section container-fluid">
      <div class="d-flex align-items-center justify-content-between" style="row-gap:10px; column-gap: 6px;">
        <ng-container>
          <div class="p-0" style="width:48%">
            <div class="d-inline-flex align-items-center justify-content-between rounded-pill p-1 w-100"
              style="border: 2px solid #8bc34a;background-color: #673AB7;">
              <span class="me-2 small"
                style="font-size: 13px; margin: 0 6px; overflow: hidden; text-overflow: ellipsis;">Total Count</span>
              <span class="d-flex align-items-center justify-content-center px-2"
                style="min-width: 50px; height: 30px; font-size:0.85rem; line-height: 4.5; font-weight: 600; border-radius: 17px;background-color: #8bc34a;">
                {{summary?.TotalCount != null ? (summary?.TotalCount) : '--'}}
              </span>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="p-0" style="width:48%">
            <div class="d-inline-flex align-items-center justify-content-between rounded-pill p-1 w-100"
              style="border: 2px solid #f06292;background-color: #673AB7;">
              <span class="me-2 small"
                style="font-size: 13px; margin: 0 6px; overflow: hidden; text-overflow: ellipsis;">Todays Count</span>
              <span class="d-flex align-items-center justify-content-center px-2"
                style="min-width: 50px; height: 30px; font-size:0.85rem; line-height: 4.5; font-weight: 600; border-radius: 17px;background-color: #f06292;">
                {{summary?.TodayCount != null ? (summary?.TodayCount) : '--'}}
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Filter section -->
    <div class="d-flex align-items-center w-100 p-3" style="gap: 0.25rem;">
      <div class="search-wrapper w-100" [formGroup]="searchForm">
        <input id="search" class=" form-control search-input" (focus)="[isSearchActive = true]" formControlName="search"
          type="text" placeholder="Search" style="height: 40px;" />

        <div class="search-result-count-input-container" *ngIf="this.isSearchActive && searchForm.get('search')?.value">
          <span>found {{this.searchFilteredBranches.length}}</span> &nbsp;|
          <button type="button" (click)="clearSearch()">
            &times;
          </button>
        </div>

      </div>

      <form [formGroup]="filterForm">
        <ng-select placeholder="Select a count type" [items]="countFilters" bindValue="value" bindLabel="label"
          formControlName="count" [searchable]="false" [clearable]="false">
        </ng-select>
      </form>
    </div>

    <div class="page-tab-container" style="background-color: #fff; position: relative;">
      <div class="d-flex justify-content-between px-2" style="font-size: 13px;">
        <div (click)="setTabList(1)" class="py-2">
          <div class="page-tabs"
            [ngStyle]="tab === 1 ? {'background-color':'#673AB7', 'color':'#fff' } : {'color':'#888888'}">
            All ( {{branches.length}} )
          </div>
        </div>
        <div (click)="setTabList(2)" class="py-2">
          <div class="page-tabs"
            [ngStyle]="tab === 2 ? {'background-color':'#673AB7', 'color':'#fff'} : {'color':'#888888'}">
            Company ( {{companyBranches.length}} )
          </div>
        </div>
        <div (click)="setTabList(3)" class="py-2">
          <div class="page-tabs"
            [ngStyle]="tab === 3 ? {'background-color':'#673AB7', 'color':'#fff'} : {'color':'#888888'}">
            Shops ( {{shopBranches.length}} )
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loading; else realContent">
    <div class="serviceItem d-flex p-2 my-2" *ngFor="let _ of [].constructor(5)">
      <!-- Left Job Box -->
      <div class="mr-2">
        <div class="jobBox d-flex flex-column align-items-center justify-content-center p-2 skeleton-box"
          style="width:80px; height:90px;">

          <div class="skeleton-text very-short mb-1"></div>
          <div class="d-flex align-items-center">
            <div class="skeleton-text very-short"></div>
          </div>

        </div>
      </div>

      <!-- Right Content -->
      <div class="row no-gutters w-100" style="overflow: hidden;">
        <div class="d-flex align-items-center justify-content-between w-100">

          <!-- Left Text Block -->
          <div class="d-flex flex-column w-75">
            <div class="skeleton-text short mb-1"></div>
            <div class="skeleton-text very-short mb-1"></div>
            <div class="skeleton-text short"></div>
          </div>

          <!-- Right Amount Block -->
          <div class="d-flex flex-column align-items-end w-25">
            <div class="skeleton-text very-short mb-1"></div>
            <div class="skeleton-text short mb-1"></div>

            <div class="skeleton-text very-short mb-1"></div>
            <div class="skeleton-text short"></div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <ng-template #realContent>
    <div *ngIf="displayedBranches.length === 0 && !loading" class="no-data-message text-center mt-4 text-muted">
      No branches data found.
    </div>

    <div class="list-section" #scrollContainer data-preserve-scroll infinite-scroll
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance"
      [infiniteScrollThrottle]="throttle" (scrolled)="onScrollDown($event)" [scrollWindow]="false"
      (scroll)="onListScroll($event)">

      <!-- Scroll progress pill -->
      <div class="scroll-progress-pill" [class.pill-visible]="showPill">
        Showing {{displayedBranches.length}} of {{this.isSearchActive ? this.searchFilteredBranches.length :
        this.filteredBranches.length}}
      </div>

      <div *ngIf="displayedBranches.length !== 0" style="margin-top: -25px;">
        <div (click)="goToDetails(item)" class="my-1 d-flex workorder-card p-2"
          *ngFor="let item of displayedBranches; trackBy: trackById">

          <div class="d-flex flex-column first-section">
            <div class="d-flex flex-fill">
              <div class="flex-fill" style="border-radius: 6px; border-width: 0.01rem ; border-style: solid;"
                [ngStyle]="{ 'background-color': 'rgba(3, 155, 229, 0.2)' , 'border-color' : 'rgba(3, 155, 229)'}">
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                  <div class="delivery-date d-flex flex-column align-items-center"
                    [ngStyle]="{'color': 'rgba(3, 155, 229)'}">
                    <div>Total</div>
                    <div class="day">{{item?.OrderCount}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mt-1 footer">
              <div class="d-flex align-self-center w-100 assigned-user-pill" style="height: 20px;"
                [ngStyle]="{ 'background-color': 'rgba(3, 155, 229, 0.2)' , 'border-color' : 'rgba(3, 155, 229)'}">
                <div class="d-flex align-items-center justify-content-center user-text-icon px-1 mb-1"
                  [ngStyle]="{'background-color': 'rgba(3, 155, 229)' , 'border-color' : 'rgba(3, 155, 229)'}">
                  Today</div>
                <div class="half-ellipsis text-center px-1 d-flex justify-content-center w-100"
                  [ngStyle]="{'color': 'rgba(3, 155, 229)'}">
                  {{item?.TodayOrderCount }}</div>
              </div>
            </div>
          </div>

          <div class="w-100 overflow-hidden pl-2 d-flex flex-column" style="overflow: hidden;">

            <div class="d-flex align-items-center justify-content-between w-100 h-100">
              <div class="d-flex flex-column justify-content-between h-100">
                <div>
                  <div class="d-flex align-items-center justify-content-between w-100">
                    <div class="totalAmount flex align-items-center" style="font-size: 0.85rem;">
                      <i class="bi bi-shop-window pr-2" style="color: rgba(3, 155, 229);"></i>
                      <strong>{{item?.BranchName}}</strong>
                    </div>
                  </div>
                  <div class="customerName mb-1" style="color: #6c757d; font-size: 0.85rem;">
                    {{item?.Place}}
                  </div>
                  <div class="d-flex align-items-center " style="font-size: 0.85rem;">
                    <div>
                      usr:
                      <span style="font-weight: 500;">{{item?.Username}}</span>
                    </div>
                    <span class="px-1">|</span>
                    <div>
                      psd:
                      <span style="font-weight: 500;">{{item?.Password}}</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between w-100 mb-1">
                  <div class="small text-muted" style="font-size: 11px;">( {{item.BranchType}}
                    ) Reg.{{item.RegisteredOn}}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
